<div class="diff-page">
  @if (error) {
    <div class="example-box">
      {{ error | json }}
    </div>
  }

  <div class="diff-toolbar">
    <div class="diff-toolbar__group">
      <kendo-combobox
        class="diff-combo diff-combo--env"
        [data]="this.environments"
        textField="text"
        valueField="value"
        [valuePrimitive]="true"
        placeholder="Left environment"
        [allowCustom]="true"
        [value]="environmentLeft()"
        (valueChange)="environmentLeft.set($event)">
      </kendo-combobox>

      <kendo-combobox
        class="diff-combo diff-combo--flow"
        [data]="this.flowsLeft()"
        textField="displayName"
        valueField="flowName"
        [valuePrimitive]="true"
        placeholder="Left flow"
        [allowCustom]="true"
        [value]="flowLeft()"
        (valueChange)="flowLeft.set($event)">
      </kendo-combobox>

      <kendo-combobox
        class="diff-combo diff-combo--version"
        [data]="this.versionsLeft()"
        placeholder="Left version"
        [allowCustom]="true"
        [(ngModel)]="this.versionLeft"
        [textField]="'name'"
        [valueField]="'name'"
        [valuePrimitive]="true">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span [title]="dataItem.name">
            {{ dataItem.name === 'current' ? 'current' : (dataItem.startTime | kendoDate: 'yyyy-MM-dd HH:mm') }}
          </span>
        </ng-template>
      </kendo-combobox>
    </div>

    <button type="button"
      class="app-pill-btn app-pill-btn--primary"
      [disabled]="!this.flowLeft() || !this.flowRight()"
      (click)="this.load()">
      <i class="ms-Icon ms-Icon--BranchCompare flex-none" aria-hidden="true"></i>
      <span>Load</span>
    </button>

    <button type="button"
      class="app-pill-btn"
      (click)="this.swap()">
      <i class="ms-Icon ms-Icon--Switch flex-none" aria-hidden="true"></i>
      <span>Swap</span>
    </button>

    <span class="diff-toolbar__spacer"></span>

    <div class="diff-toolbar__group">
      <kendo-combobox
        class="diff-combo diff-combo--env"
        [data]="this.environments"
        textField="text"
        valueField="value"
        [valuePrimitive]="true"
        placeholder="Right environment"
        [allowCustom]="true"
        [value]="environmentRight()"
        (valueChange)="environmentRight.set($event)">
      </kendo-combobox>

      <kendo-combobox
        class="diff-combo diff-combo--flow"
        [data]="this.flowsRight()"
        textField="displayName"
        valueField="flowName"
        [valuePrimitive]="true"
        placeholder="Right flow"
        [allowCustom]="true"
        [value]="flowRight()"
        (valueChange)="flowRight.set($event)">
      </kendo-combobox>

      <kendo-combobox
        class="diff-combo diff-combo--version"
        [data]="this.versionsRight()"
        placeholder="Right version"
        [allowCustom]="true"
        [(ngModel)]="this.versionRight"
        [textField]="'name'"
        [valueField]="'name'"
        [valuePrimitive]="true">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span [title]="dataItem.name">
            {{ dataItem.name === 'current' ? 'current' : (dataItem.startTime | kendoDate: 'yyyy-MM-dd HH:mm') }}
          </span>
        </ng-template>
      </kendo-combobox>
    </div>

    <button type="button"
      class="app-pill-btn"
      (click)="this.save()">
      <i class="ms-Icon ms-Icon--Save flex-none" aria-hidden="true"></i>
      <span>Save</span>
    </button>
  </div>

  <div class="diff-editor-wrap">
    <ngx-monaco-diff-editor class="monaco-editor"
      [options]="editorOptions"
      [originalModel]="originalModel"
      [modifiedModel]="modifiedModel"
    (onInit)="onInit($event)"></ngx-monaco-diff-editor>
  </div>

  @if (!this.ready()) {
    <div class="diff-loading">
      <div class="k-i-loading"></div>
    </div>
  }
</div>